// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/legacy_portal_service.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalShippingServiceGetAllShippingStatusesRequest, LegacyPortalShippingServiceGetAllShippingStatusesResponse, LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest, LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse, LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest, LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse } from "./legacy_portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.shipping.v1.LegacyPortalShippingService
 */
export const LegacyPortalShippingService = {
    typeName: "spwn.shipping.v1.LegacyPortalShippingService",
    methods: {
        /**
         * fulfillment_firestore_idを指定して配送状況を取得
         *
         * @generated from rpc spwn.shipping.v1.LegacyPortalShippingService.GetShippingStatusByFulfillmentFirestoreId
         */
        getShippingStatusByFulfillmentFirestoreId: {
            name: "GetShippingStatusByFulfillmentFirestoreId",
            I: LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdRequest,
            O: LegacyPortalShippingServiceGetShippingStatusByFulfillmentFirestoreIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * 複数の注文の配送状況をまとめて取得
         *
         * @generated from rpc spwn.shipping.v1.LegacyPortalShippingService.GetAllShippingStatuses
         */
        getAllShippingStatuses: {
            name: "GetAllShippingStatuses",
            I: LegacyPortalShippingServiceGetAllShippingStatusesRequest,
            O: LegacyPortalShippingServiceGetAllShippingStatusesResponse,
            kind: MethodKind.Unary,
        },
        /**
         * SPWNの住所を取得
         *
         * @generated from rpc spwn.shipping.v1.LegacyPortalShippingService.GetLegacyPortalAddressInfo
         */
        getLegacyPortalAddressInfo: {
            name: "GetLegacyPortalAddressInfo",
            I: LegacyPortalShippingServiceGetLegacyPortalAddressInfoRequest,
            O: LegacyPortalShippingServiceGetLegacyPortalAddressInfoResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map